/**
 * QuotaSection - Quota usage display component
 *
 * Pure presentational component showing quota usage card.
 * All data fetching and state management happens in parent.
 */
import { View } from "react-native";
import { QuotaUsageCard } from "../../../components/quota/QuotaUsageCard";

interface QuotaSectionProps {
  /** Daily analyses used */
  dailyAnalysesUsed: number;
  /** Daily analyses limit */
  dailyAnalysesLimit: number;
  /** Usage percentage (0-100) */
  usagePercent: number;
  /** Remaining analyses */
  remaining: number;
  /** Formatted reset time string */
  resetTime: string;
  /** Reset timestamp */
  resetAt: string;
  /** Current subscription tier */
  currentTier: 'free' | 'drama_plus' | 'dramax' | 'anonymous';
  /** Callback when upgrade button clicked */
  onUpgradeClick: () => void;
  /** Callback when refresh button clicked */
  onRefresh: () => Promise<void>;
  /** Loading state */
  isLoading: boolean;
  /** Error state */
  error: string | null;
}

export function QuotaSection({
  dailyAnalysesUsed,
  dailyAnalysesLimit,
  usagePercent,
  remaining,
  resetTime,
  resetAt,
  currentTier,
  onUpgradeClick,
  onRefresh,
  isLoading,
  error,
}: QuotaSectionProps) {
  return (
    <View testID="quota-section">
      <QuotaUsageCard
        dailyAnalysesUsed={dailyAnalysesUsed}
        dailyAnalysesLimit={dailyAnalysesLimit}
        usagePercent={usagePercent}
        remaining={remaining}
        resetTime={resetTime}
        resetAt={resetAt}
        currentTier={currentTier}
        onUpgradeClick={onUpgradeClick}
        onRefresh={onRefresh}
        isLoading={isLoading}
        error={error}
      />
    </View>
  );
}
